module.exports = __webpack_public_path__ + "img/cr.60df4193.svg";